export const messages = {
    "wr-dashboard.search.input.hint": "Претрага",
    "wr-dashboard.search.label.breadcrumb": "Резултати претраге",
    "wr-dashboard.search.message.empty": "Ниједна ставка се не подудара са вашом претрагом",
    "wr-dashboard.side-bar.selected.title:plural": "Изабрано ставки: {count} | {count} ставка је изабрана | Изабрано ставки: {count} | Изабрано ставки: {count}",
    "wr-dashboard.side-bar.backup-type.disk": "Диск",
    "wr-dashboard.side-bar.backup-type.file": "Датотека",
    "wr-dashboard.side-bar.backup-type.notarized": "Оверене датотеке и фасцикле",
    "wr-dashboard.side-bar.backup-type.exchange": "Апликација – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Апликација – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Апликација – стање система",
    "wr-dashboard.side-bar.backup-type.application": "Апликација",
    "wr-dashboard.backups-table.column.name": "Име",
    "wr-dashboard.backups-table.column.size": "Величина",
    "wr-dashboard.backups-table.column.version": "Последња верзија",
    "wr-dashboard.backups-table.action.delete": "Избриши",
    "wr-dashboard.backups-table.message.no-backups": "Још увек нема ниједне резервне копије у облаку",
    "wr-dashboard.backups-sidebar.label.size": "Величина",
    "wr-dashboard.backups-sidebar.label.type": "Тип",
    "wr-dashboard.backups-sidebar.label.version": "Последња верзија",
    "wr-dashboard.backups-sidebar.label.created": "Направљено",
    "wr-dashboard.backups-sidebar.label.machine": "Машина",
    "wr-dashboard.backups-sidebar.label.owner": "Власник",
    "wr-dashboard.content-table.column.name": "Име",
    "wr-dashboard.content-table.column.versions": "Верзије",
    "wr-dashboard.content-table.column.volumes": "Волумени",
    "wr-dashboard.content-table.column.path": "Путања",
    "wr-dashboard.content-table.column.size": "Величина",
    "wr-dashboard.content-table.column.version": "Последња верзија",
    "wr-dashboard.content-table.action.notary-verify": "Верификуј",
    "wr-dashboard.content-table.action.notary-get-crt": "Преузмите сертификат",
    "wr-dashboard.content-table.action.asign": "Пошаљи на потписивање",
    "wr-dashboard.content-table.action.versions": "Верзије",
    "wr-dashboard.content-table.action.restore": "Преузми",
    "wr-dashboard.content-table.label.size": "Величина",
    "wr-dashboard.content-table.label.created": "Направљено",
    "wr-dashboard.content-table.label.modified": "Измењено",
    "wr-dashboard.content-table.message.empty-folder": "Ова фасцикла је празна",
    "wr-dashboard.password-dialog-box.title.backup": "Шифрована резервна копија",
    "wr-dashboard.password-dialog-box.title.archive": "Шифрована архива",
    "wr-dashboard.password-dialog-box.message.backup": "Наведите лозинку да бисте приступили резервној копији {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Наведите лозинку да бисте приступили архиви {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Лозинка",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Лозинка није тачна",
    "wr-dashboard.form.button.open": "Отвори",
    "wr-dashboard.form.button.close": "Затвори",
    "wr-dashboard.form.button.cancel": "Откажи",
    "wr-dashboard.form.button.continue": "Настави",
    "wr-dashboard.form.button.proceed": "Настави",
    "wr-dashboard.form.button.delete": "Избриши",
    "wr-dashboard.form.button.done": "Готово",
    "wr-dashboard.form.button.retry": "Покушај поново",
    "wr-dashboard.notary.verify.view.status.downloading": "Преузимање...",
    "wr-dashboard.notary.verify.view.status.validating": "Провера ваљаности...",
    "wr-dashboard.notary.verify.view.status.pending": "Сертификат на чекању...",
    "wr-dashboard.notary.verify.view.status.fail": "Неподударање сертификата...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Преузмите сертификат",
    "wr-dashboard.notary.verify.view.file-info.name": "ИМЕ",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ПОТПИСАО/ЛА",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "ДАТУМ РЕЗЕРВНЕ КОПИЈЕ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "ДАТУМ ОВЕРЕ",
    "wr-dashboard.notary.verify.view.button.cancel": "Откажи",
    "wr-dashboard.notary.verify.view.button.done": "Готово",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Неподржана верзија прегледача",
    "wr-dashboard.versions-dialog-box.title": "Верзије датотеке {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Пошаљи на потписивање",
    "wr-dashboard.asign-dialog-box.message": "Верзија датотеке се дели, али нико не може да прикаже датотеку ако нема везу ка њој. Идите у ASign да бисте додали потписнике и делили везу.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Прикажи детаље датотеке",
    "wr-dashboard.page-not-found.title": "Страница није пронађена",
    "wr-dashboard.page-not-found.message.main": "Страница коју сте тражили није пронађена.",
    "wr-dashboard.page-not-found.message.description": "Веза је можда застарела или нисте тачно откуцали адресу.",
    "wr-dashboard.page-not-found.message.error": "Код грешке: 404",
    "wr-dashboard.server-error.title": "Сервер није доступан",
    "wr-dashboard.server-error.message": "Сервер тренутно није доступан. Покушајте поново касније.",
    "wr-dashboard.server-error.message.error": "Код грешке: 500",
    "wr-dashboard.account-menu.action.sign-out": "Одјавите се",
    "wr-dashboard.breadcrumb.item.machines": "Машине",
    "wr-dashboard.breadcrumb.item.failed-backups": "Неуспеле резервне копије",
    "wr-dashboard.machines-table.column.name": "Име",
    "wr-dashboard.machines-table.column.size": "Величина",
    "wr-dashboard.machines-table.message.no-machines": "Још увек нема ниједне машине у облаку",
    "wr-dashboard.incomplete-backups.message.status:plural": "Имате следећи број неуспелих или непотпуних резервних копија које заузимају {size} складишта: {count} | Имате {count} неуспелу или непотпуну резервну копију која заузима {size} складишта | Имате следећи број неуспелих или непотпуних резервних копија које заузимају {size} складишта: {count} | Имате следећи број неуспелих или непотпуних резервних копија које заузимају {size} складишта: {count}",
    "wr-dashboard.incomplete-backups.button.view": "Прикажите резервне копије",
    "wr-dashboard.incomplete-backups.button.delete": "Избриши резервне копије",
    "wr-dashboard.machines-table.message.space-used:plural": "Укупна искоришћеност резервних копија {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Избришите архиве",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Избришите недовршене архиве",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Избришите све недовршене архиве",
    "wr-dashboard.delete-archive.message": "Желите ли заиста трајно да избришете изабране архиве са свих локација? Сви подаци ће бити избрисани и није их могуће вратити.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Сертификат је на чекању",
    "wr-dashboard.certificate-pending-dialog-box.message": "Покушајте поново за неколико минута.",
    "wr-dashboard.form.button.ok": "У реду"
};
